import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'
import { useTenantGroup } from '../../hooks/useTenantGroup'
import { updateTenantGroup } from '../../services/api/updateTenantGroup'
import { EditEntityPage } from '../EditEntityPage/EditEntityPage'
import { buildTenantGroupEditRows } from './helpers/buildTenantGroupEditRows'

export function TenantGroupEditPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const { getToken } = useAuth()
  const { tenantGroup, isLoading, error } = useTenantGroup(id ?? '')

  const rows = tenantGroup ? buildTenantGroupEditRows(tenantGroup) : []

  async function handleSubmit(body: Record<string, unknown>) {
    await updateTenantGroup(await getToken(), id ?? '', body)
    navigate(`/tenant-groups/${id}`)
  }

  return (
    <EditEntityPage
      title={tenantGroup ? `Edit Tenant Group - ${tenantGroup.code}` : 'Edit Tenant Group'}
      backTo={`/tenant-groups/${id}`}
      loadingLabel="tenant group"
      rows={rows}
      isLoading={isLoading}
      loadError={error}
      onSubmit={handleSubmit}
    />
  )
}
